//'chords': ['major', 'minor', 'minor', 'major', 'major', 'minor', 'diminished']


const chords = {
    "major": {
        "name": "Major",
        "notes": [0, 4, 7]
    },
    "minor": {
        "name": "Minor",
        "notes": [0, 3, 7]
    },
    "diminished": {
        "name": "Diminished",
        "notes": [0, 3, 6]
    },
    "augmented": {
        "name": "Augmented",
        "notes": [0, 4, 8]
    },
    "major7": {
        "name": "Major 7",
        "notes": [0, 4, 7, 11]
    },
    "minor7": {
        "name": "Minor 7",
        "notes": [0, 3, 7, 10]
    }
}


export default chords;